import React, { useState, useEffect } from 'react';
import styles from './Parent.module.sass';
import NavPanel from '../NavPanel/NavPanel';
import Table from '../Table/Table';
import { withRoleRedirectComp } from '../../../hoc/redirectComp';
import { haveNoLoginRedirect } from '../../../hoc/redirectComp';
import { compose } from 'redux';
import AddCoach from '../AddCoach/AddCoach';
import FirstPlayerAddBlock from '../Table/FirstPlayerAddBlock';

function Parent(props) {
  const [isShowSection, setIsShowSection] = useState(() => {
    const isShowSection = localStorage.getItem('isShowSection');
    return isShowSection ? JSON.parse(isShowSection) : true;
  });

  useEffect(() => {
    localStorage.setItem('isShowSection', JSON.stringify(isShowSection));
  }, [isShowSection]);

  const removeSection = () => {
    setIsShowSection(false);
    localStorage.setItem('isShowSection', JSON.stringify(false));
  };

  const count = props.playerData.childInfo.childrenCount;

  return (
    <>
      <main className={styles.main}>
        <NavPanel
          playerData={props.playerData}
          setUserDataStep1={props.setUserDataStep1}
          setUserDataStep3={props.setUserDataStep3}
          signUpData={props.signUpData}
          amountPlayer={props.amountPlayer}
        />
        <Table
          playerData={props.playerData}
          setRole={props.setRole}
          setOnlyChildData={props.setOnlyChildData}
        />
        {isShowSection && <AddCoach removeSection={removeSection} />}
        {!count && <FirstPlayerAddBlock />}
      </main>
    </>
  );
}

export default compose(withRoleRedirectComp, haveNoLoginRedirect)(Parent);
